
import {
    ProcessadorDeRespostaDeFormulario,
    TextoProcessado,
} from '@/dominio/processamento/processador/resposta-formulario/ProcessadorDeRespostaDeFormulario';
import { Formulario } from '@/dominio/formulario/Formulario';
import { QuestaoDeOpcoes } from '@/dominio/formulario/questoes/opcoes/QuestaoDeOpcoes';
import { QuestaoDeSelecao } from '@/dominio/formulario/questoes/selecao/QuestaoDeSelecao';
import { defineComponent } from 'vue';
import QuestaoOpcoes from './questao-opcoes/QuestaoOpcoesComponent.vue';
import QuestaoSelecoes from './questao-selecoes/QuestaoSelecoesComponent.vue';
import BotaoGerarRelatorio from './BotaoGerarRelatorio.vue';

export default defineComponent({
    name: 'FormularioComponent',
    props: {
        formulario: {
            type: Formulario,
            required: true,
        },
        processadorFormulario: {
            type: ProcessadorDeRespostaDeFormulario,
            required: true,
        },
    },
    data() {
        return {
            esteFormulario: this.formulario,
        };
    },
    components: {
        QuestaoOpcoes,
        QuestaoSelecoes,
        BotaoGerarRelatorio,
    },
    methods: {
        gerouRelatorio(textosProcessados: TextoProcessado[]) {
            this.$emit('gerouRelatorio', textosProcessados);
        },
    },
    emits: ['gerouRelatorio'],
});
